import React, { useState, useEffect, useCallback } from 'react';

import { ClientFilterTypes } from '../enums';
import { CompanySelectModel } from 'api/adminApiClient';
import CompanyFilter from 'components/filters/CompanyFilter';
import { getApprovedClientsCompanies } from 'redux/reducers/clientSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

export interface ClientsFilters {
  [ClientFilterTypes.Company]?: string[];
}

type Props = {
  filters: ClientsFilters;
  onChange: (data: ClientsFilters) => void;
};

export default function ClientsFilter(props: Props) {
  const { filters, onChange } = props;
  const [companies, setCompanies] = useState<CompanySelectModel[]>([]);
  const [isCompaniesLoaded, setIsCompaniesLoaded] = useState(false);

  const dispatch = useAppDispatch();

  const loadCompanies = useCallback(async () => {
    const result = await dispatch(getApprovedClientsCompanies());

    if (getApprovedClientsCompanies.fulfilled.match(result)) {
      setCompanies(result.payload);
    }
    setIsCompaniesLoaded(true);
  }, [dispatch]);

  useEffect(() => {
    loadCompanies();
  }, [loadCompanies]);

  return (
    <CompanyFilter
      filters={filters}
      onChange={onChange}
      companies={companies}
      isCompaniesLoaded={isCompaniesLoaded}
    />
  );
}
